export function contrastRatio(a, b) {
    const luminance = rgb => rgb.map(v => v / 255)
        .map(v => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4)
        .reduce((sum, v, i) => sum + v * [.2126, .7152, .0722][i], 0);
    const values = [luminance(a), luminance(b)].sort((x, y) => y - x);
    return (values[0] + .05) / (values[1] + .05);
}

// Graphic accents target 3:1, with a small allowance for rounding.
export function darkHighlight(original, surfaces, minimum = 3.1) {
    for (let tint = 0; tint <= 100; tint++) {
        const colour = original.map(v => Math.round(v + (255 - v) * tint / 100));
        if (surfaces.every(surface => contrastRatio(colour, surface) >= minimum)) return colour;
    }
    return [255, 255, 255];
}

export default function highlightContrast() {
    const selector = '.lds-ghost-entry-rule, .gh-card-primary-tag-rule, .lds-ghost-resource-rule';
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const context = canvas.getContext('2d', {willReadFrequently: true});
    if (!context) return;
    const rgb = colour => {
        context.clearRect(0, 0, 1, 1);
        context.fillStyle = colour;
        context.fillRect(0, 0, 1, 1);
        return Array.from(context.getImageData(0, 0, 1, 1).data).slice(0, 3);
    };
    const refresh = () => {
        if (document.documentElement.dataset.appearance !== 'dark') return;
        const bodyStyle = getComputedStyle(document.body);
        const surfaces = ['--lds-colour-surface', '--lds-colour-surface-soft'].map(name => rgb(bodyStyle.getPropertyValue(name).trim()));
        const brand = bodyStyle.getPropertyValue('--lds-ghost-brand-accent').trim() || bodyStyle.getPropertyValue('--lds-colour-accent').trim();
        if (brand) document.body.style.setProperty('--lds-ghost-dark-brand-accent', `rgb(${darkHighlight(rgb(brand), surfaces).join(',')})`);
        document.querySelectorAll(selector).forEach(rule => {
            const original = getComputedStyle(rule).getPropertyValue('--lds-ghost-highlight-source').trim();
            if (!original) return;
            const colour = darkHighlight(rgb(original), surfaces);
            rule.style.setProperty('--lds-ghost-dark-highlight', `rgb(${colour.join(',')})`);
        });
    };
    refresh();
    document.addEventListener('lds:appearance', refresh);
    // Include cards appended by archive filters and load-more controls.
    new MutationObserver(records => {
        if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) refresh();
    }).observe(document.body, {childList: true, subtree: true});
}
